/** Appraisal dates as staff read them: date-only values as written, timestamps in Pacific business time. */
export function appraisalDate(value: string | null | undefined, includeTime = false): string {
  if (!value) {
    return 'Not received';
  }
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
  const date = new Date(dateOnly ? `${value}T12:00:00Z` : value);
  if (!Number.isFinite(date.getTime())) {
    return 'Date unavailable';
  }
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: dateOnly ? 'UTC' : 'America/Los_Angeles',
    ...(includeTime && !dateOnly ? ({ hour: 'numeric', minute: '2-digit', timeZoneName: 'short' } as const) : {})
  }).format(date);
}
